<template>
    <div class="credit-invoice">
      <div class="header-section">
        <h2 class="page-title">Credito Fattura</h2>
        <p class="subtitle">Gestione e verifica dei crediti fattura</p>
      </div>
      
      <div class="customer-section">
        <div class="section-header">
          <h3>Dati Cliente</h3>
        </div>
        
        <div class="customer-details">
          <div class="customer-info">
            <div class="data-row">
              <span class="label">Ragione Sociale:</span>
              <span class="value">Azienda Demo S.p.A.</span>
            </div>
            <div class="data-row">
              <span class="label">Partita IVA:</span>
              <span class="value">IT12345678901</span>
            </div>
            <div class="data-row">
              <span class="label">Indirizzo:</span>
              <span class="value">Via Roma 123, 70121 Bari (BA)</span>
            </div>
            <div class="data-row">
              <span class="label">Email:</span>
              <span class="value">info@aziendademo.com</span>
            </div>
          </div>
          
          <div class="customer-contact">
            <div class="contact-info">
              <div class="data-row">
                <span class="label">Contatto:</span>
                <span class="value">Mario Rossi</span>
              </div>
              <div class="data-row">
                <span class="label">Telefono:</span>
                <span class="value">+39 123 456 7890</span>
              </div>
            </div>
            
            <div class="contact-actions">
              <Button icon="pi pi-phone" label="Chiama cliente" class="p-button-outlined" @click="chiamaCliente" />
              <Button icon="pi pi-envelope" label="Invia email" class="p-button-outlined" @click="inviaEmail" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="invoice-details">
        <div class="section-header">
          <h3>Dettagli Fattura</h3>
        </div>
        
        <div class="invoice-data">
          <div class="data-row">
            <span class="label">Numero Fattura:</span>
            <span class="value">FAT-2025-00123</span>
          </div>
          <div class="data-row">
            <span class="label">Data Emissione:</span>
            <span class="value">15/04/2025</span>
          </div>
          <div class="data-row">
            <span class="label">Importo Totale:</span>
            <span class="value">€ 2.450,00</span>
          </div>
          <div class="data-row">
            <span class="label">Credito Residuo:</span>
            <span class="value font-bold">€ 1.250,00</span>
          </div>
          <div class="data-row">
            <span class="label">Scadenza:</span>
            <span class="value">15/05/2025</span>
          </div>
        </div>
      </div>
      
      <div class="payment-section">
        <div class="section-header">
          <h3>Contabilizzazione Movimento Bancario</h3>
        </div>
        
        <div class="payment-details">
          <div class="data-grid">
            <div class="data-row">
              <span class="label">Data Movimento:</span>
              <span class="value">03/05/2025</span>
            </div>
            <div class="data-row">
              <span class="label">Importo:</span>
              <span class="value">€ 1.250,00</span>
            </div>
            <div class="data-row">
              <span class="label">Causale:</span>
              <span class="value">Saldo fattura FAT-2025-00123</span>
            </div>
            <div class="data-row">
              <span class="label">IBAN Origine:</span>
              <span class="value">IT60X0542811101000000123456</span>
            </div>
            <div class="data-row">
              <span class="label">Riferimento:</span>
              <span class="value">BONIFICO 00359782</span>
            </div>
          </div>
          
          <div class="payment-notes">
            <span class="label">Note:</span>
            <p class="value">Il bonifico corrisponde esattamente all'importo residuo della fattura. Verificare la corrispondenza del codice cliente.</p>
          </div>
          
          <div class="action-container">
            <div class="info-box">
              <i class="pi pi-info-circle info-icon"></i>
              <div class="info-content">
                <span class="info-title">Stato attuale</span>
                <span class="info-value">In attesa di approvazione</span>
              </div>
            </div>
            
            <div class="info-box">
              <i class="pi pi-calendar info-icon"></i>
              <div class="info-content">
                <span class="info-title">Data ricezione</span>
                <span class="info-value">03/05/2025</span>
              </div>
            </div>
            
            <div class="info-box">
              <i class="pi pi-user info-icon"></i>
              <div class="info-content">
                <span class="info-title">Operatore</span>
                <span class="info-value">Laura Bianchi</span>
              </div>
            </div>
            
            <div class="action-buttons">
              <Button label="Non approvare" icon="pi pi-times" class="p-button-danger btn-reject" @click="nonApprovaMovimento" />
              <Button label="Approva movimento" icon="pi pi-check" class="p-button-success btn-approve" @click="approvaMovimento" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, getCurrentInstance } from 'vue';
  import Service from '@/services/ask-pratiche/pratiche-wizard';
  import { useToast } from 'primevue/usetoast';
  
  export default {
    setup() {
      const toast = useToast();
      const loading = ref(false);
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus;
      const service = new Service(self.$eventBus);
      const statoMovimento = ref('in_attesa');
      
      const chiamaCliente = () => {
        toast.add({
          severity: 'info',
          summary: 'Chiamata in corso',
          detail: 'Inizializzazione chiamata al numero +39 123 456 7890',
          life: 3000
        });
        
        // Implementazione reale: qui andrà la logica per integrare un sistema di telefonia
      };
      
      const inviaEmail = () => {
        toast.add({
          severity: 'info',
          summary: 'Email',
          detail: 'Apertura client email',
          life: 3000
        });
        
        window.open('mailto:info@aziendademo.com?subject=Fattura%20FAT-2025-00123');
      };
      
      const approvaMovimento = () => {
        loading.value = true;
        
        // Simulazione della chiamata API
        setTimeout(() => {
          statoMovimento.value = 'approvato';
          loading.value = false;
          
          toast.add({
            severity: 'success',
            summary: 'Movimento approvato',
            detail: 'Il movimento bancario è stato approvato con successo',
            life: 3000
          });
        }, 1000);
        
        // Implementazione futura con il backend
        // service.approvaMovimento(idMovimento)
        //   .then((response) => {
        //     statoMovimento.value = 'approvato';
        //     toast.add({
        //       severity: 'success',
        //       summary: 'Movimento approvato',
        //       detail: 'Il movimento bancario è stato approvato con successo',
        //       life: 3000
        //     });
        //   })
        //   .catch((error) => {
        //     toast.add({
        //       severity: 'error',
        //       summary: 'Errore',
        //       detail: 'Impossibile approvare il movimento',
        //       life: 3000
        //     });
        //   })
        //   .finally(() => {
        //     loading.value = false;
        //   });
      };
      
      const nonApprovaMovimento = () => {
        loading.value = true;
        
        // Simulazione della chiamata API
        setTimeout(() => {
          statoMovimento.value = 'rifiutato';
          loading.value = false;
          
          toast.add({
            severity: 'error',
            summary: 'Movimento non approvato',
            detail: 'Il movimento bancario è stato rifiutato',
            life: 3000
          });
        }, 1000);
        
        // Implementazione futura con il backend
        // service.rifiutaMovimento(idMovimento)
        //   .then((response) => {
        //     statoMovimento.value = 'rifiutato';
        //     toast.add({
        //       severity: 'error',
        //       summary: 'Movimento non approvato',
        //       detail: 'Il movimento bancario è stato rifiutato',
        //       life: 3000
        //     });
        //   })
        //   .catch((error) => {
        //     toast.add({
        //       severity: 'error',
        //       summary: 'Errore',
        //       detail: 'Impossibile rifiutare il movimento',
        //       life: 3000
        //     });
        //   })
        //   .finally(() => {
        //     loading.value = false;
        //   });
      };
  
      const caricaDatiCredito = async () => {
        loading.value = true;
        
        try {
          // Qui verrà implementata la chiamata al backend per ottenere i dati della fattura e del movimento
          // const risposta = await service.getDatiCredito(idFattura);
          // datiCredito.value = risposta.items;
          
          // Per ora utilizziamo i dati di esempio
          console.log('Caricati dati del credito fattura');
        } catch (errore) {
          toast.add({
            severity: 'error',
            summary: 'Errore di caricamento',
            detail: 'Impossibile caricare i dati del credito',
            life: 3000
          });
        } finally {
          loading.value = false;
        }
      };
  
      onMounted(() => {
        // Simulazione del caricamento dei dati
        caricaDatiCredito();
      });
  
      return {
        loading,
        statoMovimento,
        chiamaCliente,
        inviaEmail,
        approvaMovimento,
        nonApprovaMovimento
      };
    }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
  
  .credit-invoice {
    font-family: 'Montserrat', sans-serif;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 1.5rem;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 1rem;
  }
  
  .page-title {
    font-size: 1.8rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
  }
  
  .subtitle {
    color: #7f8c8d;
    font-size: 1rem;
    margin-top: 0.5rem;
  }
  
  .customer-section,
  .invoice-details,
  .payment-section {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 1.5rem;
    overflow: hidden;
  }
  
  .section-header {
    background-color: #f8f9fa;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #eaeaea;
  }
  
  .section-header h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #3498db;
    margin: 0;
  }
  
  .customer-details,
  .invoice-data,
  .payment-details {
    padding: 1.5rem;
  }
  
  .customer-details {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }
  
  .customer-info {
    flex: 1;
    min-width: 300px;
  }
  
  .customer-contact {
    flex: 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .contact-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .data-row {
    display: flex;
    margin-bottom: 0.8rem;
  }
  
  .label {
    flex: 0 0 150px;
    font-weight: 600;
    color: #7f8c8d;
  }
  
  .value {
    flex: 1;
    color: #2c3e50;
  }
  
  .font-bold {
    font-weight: 600;
  }
  
  .data-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .payment-notes {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #eaeaea;
  }
  
  .payment-notes p {
    margin-top: 0.5rem;
  }
  
  .action-container {
    margin-top: 2rem;
    border-top: 1px solid #eaeaea;
    padding-top: 1.5rem;
  }
  
  .info-box {
    display: flex;
    align-items: center;
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
  }
  
  .info-icon {
    font-size: 1.5rem;
    color: #3498db;
    margin-right: 1rem;
  }
  
  .info-content {
    display: flex;
    flex-direction: column;
  }
  
  .info-title {
    font-size: 0.8rem;
    color: #7f8c8d;
  }
  
  .info-value {
    font-weight: 600;
    color: #2c3e50;
  }
  
  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
  
  .btn-reject, .btn-approve {
    padding: 0.8rem 1.5rem;
    font-weight: 600;
  }
  
  @media (max-width: 768px) {
    .customer-details {
      flex-direction: column;
      gap: 1.5rem;
    }
    
    .data-grid {
      grid-template-columns: 1fr;
    }
    
    .action-buttons {
      flex-direction: column;
    }
  }
  </style>